<div class="root row align-center">
  <app-badges-progress-card [currentUser]="currentUser"></app-badges-progress-card>
  <div class="spacer"></div>
  <app-badges-earned-card [currentUser]="currentUser"></app-badges-earned-card>
</div>
